<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Attendies
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white p-8">
      <div class="mt-4">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-color"
        >
          <el-table-column prop="city" label="Sr No." min-width="50px">
            <template slot-scope="">
              <P class="text-gray">2</P>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="Student Name" min-width="150px">
            <template slot-scope="">
              <P class="text-gray">Mohit</P>
            </template>
          </el-table-column>

          <el-table-column prop="city" label="Learnig Report" min-width="150px">
            <template slot-scope="">
              <P class="text-gray">346823743287</P>
            </template>
          </el-table-column>

          <el-table-column prop="city" label="Status" min-width="150px">
            <template slot-scope="">
              <P class="text-success">Completed</P>
            </template>
          </el-table-column>

          <el-table-column prop="city" label="Certificate" min-width="180px">
            <template slot-scope="">
              <div class="flex gap-2 items-center">
                <vs-button
                  type="success"
                  class="rounded-lg bg-success border-0 text-white font-semibold py-2 px-8 sm-fsize14"
                >
                  Approve
                </vs-button>
                <vs-button
                  type="primary"
                  class="rounded-lg bg-primary border-0 text-white font-semibold py-2 px-8 sm-fsize14"
                >
                  Reject
                </vs-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="w-full flex justify-end mt-6">
        <el-pagination
          background
          layout="prev,pager,next"
          :total="1000"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: "",
      centerDialogVisibleg: false,
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
    };
  },
  methods: {},
};
</script>
